module.exports = new __parcel__URL__("indiana-jones-and-the-last-crusade.fca31af3.jpg").toString();